<div class="col">
  <div class="row mb-3">
    <div class="col">
      <h4>
        <em class="fas fa-user-edit pe-2"></em>
        {{ heading | translate }}
      </h4>
    </div>
    <div class="col-auto">
      <button mat-icon-button color="warn" (click)="close(true)">
        <em class="fas fa-times fa-1_5x"></em>
      </button>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col">
      <iim-advanced-autocomplete
        [formControl]="approverCtrl"
        [showLabel]="true"
        [label]="label | translate"
        [required]="data.approverRequired"
        >
        @for (approver of data.possibleApprovers; track approver) {
          <iim-autocomplete-option [value]="approver">
            {{ approver | person }}
          </iim-autocomplete-option>
        }
      </iim-advanced-autocomplete>
    </div>
  </div>
  <div class="row justify-content-end">
    <div class="col-md-auto col-sm-12 mb-1">
      <button
        class="btn btn-primary w-100 btn-sm"
        data-cy="SELECT_APPROVER"
        (click)="close(false, approverCtrl.value)"
        [disabled]="!approverCtrl.value && data.approverRequired"
        >
        @if (approverCtrl.value || data.approverRequired) {
          <span>{{ 'Auswählen' | translate }}</span>
        }
        @if (!approverCtrl.value && !data.approverRequired) {
          <span>
            {{ 'ohne Rücksprache fortfahren' | translate }}
          </span>
        }
      </button>
    </div>
  </div>
</div>
